import React from 'react';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Typography from '@mui/material/Typography';

const NRMessageList = ({ rules }) => {
  if (!Array.isArray(rules) || rules.length === 0) return null;

  return (
    <List
      dense
      disablePadding
      sx={{
        listStyleType: 'disc',
        pl: 2.25
      }}
    >
      {rules.map((rule, idx) => (
        <ListItem
          key={idx}
          sx={{
            display: 'list-item',
            pt: 0,
            pb: 0,
            pl: 0,
            lineHeight: '14px',
            fontSize: '12px',
            '&::marker': {
              fontSize: 18
            }
          }}
        >
          <Typography color="error" variant="caption">
            {rule}
          </Typography>
        </ListItem>
      ))}
    </List>
  );
};

export default NRMessageList;
